"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultReceiptStyle = void 0;
const Alignment_1 = require("../../enums/Alignment");
const receiptDescriptionText = `Make sure that the photo is of the whole receipt and that it fits in the photo.

If you have a digital receipt, please upload it as a PDF or Image.
`;
exports.defaultReceiptStyle = {
    formTitle: 'Fill in this form to take a photo',
    formStyle: {
        backgroundColor: 'ffffff',
        fontSize: '16px',
        color: '000000',
        font: 'arial',
    },
    formSubmitButtonText: 'SUBMIT',
    formSubmitButtonStyle: {
        backgroundColor: '58BFEC',
        fontSize: '24px',
        color: 'ffffff',
        font: 'bebas',
    },
    receiptTitle: 'Register receipt',
    receiptTitleTextStyle: {
        fontSize: '24px',
        color: 'ffffff',
        font: 'arial',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    receiptDescriptionText: receiptDescriptionText,
    descriptionTextStyle: {
        fontSize: '16px',
        color: 'ffffff',
        font: 'arial',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    scanCompletedTitle: 'Scan Completed',
    scanCompletedTitleTextStyle: {
        fontSize: '24px',
        color: 'ffffff',
        font: 'arial',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    scanCompletedInputFieldDate: 'Date',
    scanCompletedInputFieldProduct: 'Product',
    scanCompletedInputFieldPrice: 'Price',
    scanCompletedInputFieldStore: 'Store',
    scanCompletedInputFieldTextStyle: {
        backgroundColor: '15263A',
        fontSize: '16px',
        color: 'ffffff',
        font: 'arial',
        borderRadius: '0px',
        textAlign: Alignment_1.Alignment.LEFT,
    },
    takePhotoButtonText: 'Take Photo',
    takePhotoButtonTextStyle: {
        backgroundColor: '58BFEC',
        fontSize: '24px',
        color: 'ffffff',
        font: 'bebas',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    openLibraryButtonText: 'Upload Files',
    openLibraryButtonTextStyle: {
        backgroundColor: 'ffffff',
        fontSize: '24px',
        color: '58BFEC',
        font: 'bebas',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    confirmButtonText: 'Confirm',
    confirmButtonTextStyle: {
        backgroundColor: '58BFEC',
        fontSize: '24px',
        color: 'ffffff',
        font: 'bebas',
        top: '85%',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    submitButtonText: 'Submit',
    submitButtonTextStyle: {
        backgroundColor: '58BFEC',
        fontSize: '24px',
        color: 'ffffff',
        font: 'bebas',
        top: '85%',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    errorPopupText: 'The receipt is not valid or could not be recognized. Please make sure that the receipt has a valid date and that the photo it bright and clear.',
    errorPopupTextStyle: {
        backgroundColor: 'ffffff',
        fontSize: '16px',
        color: '000000',
        font: 'arial',
        borderRadius: '12px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    scanCompletedPopUpText: 'The receipt has been successfully submitted and the reward has been unlocked.',
    scanCompletedPopUpStyle: {
        backgroundColor: 'ffffff',
        fontSize: '16px',
        color: '000000',
        font: 'arial',
        borderRadius: '12px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    ctaButtonText: 'Go to game',
    ctaUrl: '',
    ctaButtonStyle: {
        backgroundColor: '58BFEC',
        fontSize: '22px',
        color: 'ffffff',
        font: 'bebas',
        textAlign: Alignment_1.Alignment.CENTER,
    },
};
